import { useNavigate } from 'react-router-dom';
import { useFriends } from '@/hooks/useFriends';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { OnlineStatusIndicator } from '@/components/OnlineStatusIndicator';
import { useOnlinePresenceContext } from '@/contexts/OnlinePresenceContext';
import { Button } from '@/components/ui/button';
import { ChevronRight, Users } from 'lucide-react';

export function FriendsOnlineWidget() {
  const navigate = useNavigate();
  const { friendProfiles, friendCount, isLoading } = useFriends();
  const { isUserOnline } = useOnlinePresenceContext();

  if (isLoading || friendCount === 0) return null;

  // Show up to 6 friends
  const displayFriends = friendProfiles.slice(0, 6);

  return (
    <section>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-accent/20">
            <Users className="w-5 h-5 text-accent" />
          </div>
          <div>
            <h3 className="font-bold text-foreground">Bạn bè</h3>
            <p className="text-xs text-muted-foreground">{friendCount} bạn bè</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="text-muted-foreground hover:text-accent h-8 px-2"
          onClick={() => navigate('/following')}
        >
          Tất cả
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-1 scrollbar-hide">
        {displayFriends.map((friend: any) => (
          <div
            key={friend.id}
            className="flex flex-col items-center gap-1.5 cursor-pointer flex-shrink-0"
            onClick={() => navigate(`/players/${friend.id}`)}
          >
            <div className="relative">
              <Avatar className="w-14 h-14 ring-2 ring-border">
                <AvatarImage src={friend.avatar || undefined} />
                <AvatarFallback className="bg-primary/10 text-primary font-bold text-sm">
                  {friend.name?.charAt(0)?.toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <OnlineStatusIndicator isOnline={isUserOnline(friend.id)} size="sm" className="absolute -bottom-0.5 -right-0.5" />
            </div>
            <p className="text-xs text-foreground font-medium w-16 text-center truncate">
              {friend.name?.split(' ').pop()}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
